import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  NgZone,
  OnInit
} from '@angular/core';

import {
  BlockUI,
  NgBlockUI
} from 'ng-block-ui';

import { HaynesProElectronicLocationSystemModel } from '../typings/haynes-pro.diagnostic-tool.electronic-location-details';
import { HaynesProService }                       from '../haynes-pro.service';
import { MessagesService }                        from '../../messages/messages.service';
import { VehicleModel }                           from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-fuse-locations',
  styles: [ require('./haynes-pro.diagnostic-tool.fuse-locations.component.scss') ],
  template: require('./haynes-pro.diagnostic-tool.fuse-locations.component.html')
})
export class HaynesProDiagnosticToolFuseLocationsComponent implements OnInit {

  @BlockUI('haynesProFuseLocationsBlock') block : NgBlockUI;
  @Input() isActive : boolean;
  @Input() vehicle  : VehicleModel;

  location  : HaynesProElectronicLocationSystemModel = null;
  subGroups : Array<HaynesProElectronicLocationSystemModel>;

  isAnimating  = false;
  showDetails  = false;

  constructor (
    private cdr              : ChangeDetectorRef,
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService,
    private messagesService  : MessagesService,
    private zone             : NgZone
  ) {}

  ngOnInit () : void {
    this.block.start();

    this.haynesProService.getFuseLocations(this.vehicle)
    .then(( fuseLocations : Array<any> ) => {
      this.subGroups = fuseLocations.map(
        ( fuse : any ) => this.haynesProService.mapFuseLocationToSystem(fuse)
      );
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  backToList () : void {
    if (this.subGroups) {
      this.subGroups.forEach(( subGroup : any ) => subGroup.selected = false);
    }

    this.isAnimating = true;
    this.showDetails = false;

    this.cdr.markForCheck();

    setTimeout(() => this.isAnimating = false, 450);
  }

  handleSubgroupSelection ( subGroup : HaynesProElectronicLocationSystemModel ) : void {
    this.isAnimating = false;
    this.location    = null;
    this.showDetails = false;
    this.location    = subGroup;

    this.zone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.zone.run(() => {
            this.isAnimating = true;
            this.showDetails = true;

            this.cdr.markForCheck();

            setTimeout(() => this.isAnimating = false, 450);
          });
        });
      });
    });
  }

  onCssTransitionEnd ( evt : TransitionEvent ) : void {
    const target = (evt.target as HTMLElement);

    if (!target.classList.contains('shell-details')) {
      return;
    }

    if (evt.propertyName !== 'transform' && evt.propertyName !== 'opacity') {
      return;
    }

    this.isAnimating = false;
  }
}
